import { Box, Grid, Switch } from "@mui/joy";
import DarkCard from "../../../common/DarkCard";
import DarkTypography from "../../../common/DarkTypography";
import TrainingTemplateResourceRow from "./TrainingTemplateResourceRow";
import type { TrainingTemplate } from "../../../../api/training/Training.typed";

type Props = {
  actionsWidth: number;
  selected: TrainingTemplate;
  canEdit: boolean;
  isUploading: boolean;
  onIsSdiChange: (value: boolean) => void;
  onUploadMedical: (field: "agreement" | "disclaimer", file?: File | null) => void;
};

export default function TrainingTemplateSdiCard(props: Props) {
  const { actionsWidth, selected, canEdit, isUploading, onIsSdiChange, onUploadMedical } = props;

  return (
    <Grid xs={12}>
      <DarkCard dense sx={{ mt: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
          <DarkTypography colorVariant="accent">SDI</DarkTypography>
          <Switch
            checked={!!selected.IsSDI}
            onChange={(event) => onIsSdiChange(event.target.checked)}
            color={selected.IsSDI ? "success" : "neutral"}
          />
        </Box>
        {selected.IsSDI ? (
          <Grid container spacing={2}>
            <TrainingTemplateResourceRow
              actionsWidth={actionsWidth}
              rowLabel="Décharge médicale"
              resourceUrl={selected.MedicalAgreement}
              openAriaLabel="Ouvrir la décharge médicale"
              uploadAriaLabel="Importer la décharge médicale"
              canEdit={canEdit}
              isUploading={isUploading}
              onPickFiles={(file) => onUploadMedical("agreement", file)}
              trailingSlot={<Box sx={{ width: 36, height: 36 }} />}
            />
            <TrainingTemplateResourceRow
              actionsWidth={actionsWidth}
              rowLabel="Décharge de responsabilité"
              resourceUrl={selected.MedicalDisclaimer}
              openAriaLabel="Ouvrir la décharge de responsabilité"
              uploadAriaLabel="Importer la décharge de responsabilité"
              canEdit={canEdit}
              isUploading={isUploading}
              onPickFiles={(file) => onUploadMedical("disclaimer", file)}
            />
          </Grid>
        ) : null}
      </DarkCard>
    </Grid>
  );
}
